import { type FC, useMemo, useRef, useState } from "react";
import { csrfToken } from "@root/shared/utils/csrf";
import { Button } from "@root/shared/components/Button";
import { Link } from "@root/shared/components/Link";
import * as styles from "./styles.css";

type OneTimeScoutFormProps = {
  // フォームの送信先URL
  actionUrl: string;
  // スカウト求職者詳細URL
  scoutDetailUrl: string;
  // クライアントID
  clientId: number;
  // ユーザーID
  userId: number;
  // 求人ID
  workId: number;
  // SP画面かどうか
  isSp: boolean;
  // UTMキャンペーンパラメータ（メールID識別用）
  utmCampaign?: string;
};

export const OneTimeScoutForm: FC<OneTimeScoutFormProps> = ({
  actionUrl,
  scoutDetailUrl,
  clientId,
  userId,
  workId,
  isSp,
  utmCampaign,
}) => {
  const formEl = useRef<HTMLFormElement>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = () => {
    // 既に送信中の場合は何もしない
    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true);
    formEl.current?.submit();
  };
  const authenticityToken = useMemo(() => csrfToken(), []);

  return (
    <div className={styles.container}>
      {isSp ? (
        <p className={styles.text}>
          この求職者に
          <br />
          スカウト送信しますか？
        </p>
      ) : (
        <p className={styles.text}>この求職者にスカウト送信しますか？</p>
      )}
      <form ref={formEl} action={actionUrl} method="post" id="scout-one-time-form">
        <input type="hidden" name="authenticity_token" value={authenticityToken} />

        <input type="hidden" name="token_client_id" value={clientId} />
        <input type="hidden" name="token_user_id" value={userId} />
        <input type="hidden" name="token_work_id" value={workId} />
        <input type="hidden" name="utm_campaign" value={utmCampaign} />

        <div className={styles.buttonBox}>
          <Link href={scoutDetailUrl} className={styles.button} theme="secondary" size="large">
            求職者の詳細を確認する
          </Link>
          <Button
            onClick={handleSubmit}
            className={styles.button}
            theme="primary"
            size="large"
            disabled={isSubmitting}
          >
            送信する
          </Button>
        </div>
      </form>
    </div>
  );
};
